export const messages = {
  page: {
    title: {
      id: 'contactUs.Page.Title',
      defaultMessage: 'Contact Us',
    },
  },
  columns: {
    name: {
      id: 'contactUs.Columns.Name',
      defaultMessage: 'Name',
    },
    contactInfo: {
      id: 'contactUs.Columns.ContactInfo',
      defaultMessage: 'Contact Information',
    },
  },
  contact: {
    phone: {
      id: 'contactUs.Contact.Phone',
      defaultMessage: 'Phone: {phone}',
    },
    fax: {
      id: 'contactUs.Contact.Fax',
      defaultMessage: 'Fax: {fax}',
    },
  },
};
